"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSchema = void 0;
const zod_1 = require("zod");
exports.LanguageSchema = zod_1.z.union([
    zod_1.z.literal('de'),
    zod_1.z.literal('en'),
    zod_1.z.literal('es'),
    zod_1.z.literal('fr'),
    zod_1.z.literal('nl'),
]);
//# sourceMappingURL=translation.js.map